import { Component, Input } from '@angular/core';
import type { FormControl } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslatePipe } from '@core/i18n-legacy';
import { RenderDirective } from '@core/prosemirror-legacy/angular';
import {
  ProsemirrorDefaultConfig,
  ProsemirrorDefaultConfigDirective,
  WysiwygComponent,
} from '@core/prosemirror-legacy/webapp';
import type { EditorJSONState } from '@core/prosemirror-types';
import {
  BadgeComponent,
  BoxComponent,
  FormFieldComponent,
  HeadingComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-requisitions-context-form',
  templateUrl: './requisitions-context-form.component.html',
  styleUrls: ['./requisitions-context-form.component.less'],
  imports: [
    BoxComponent,
    FormFieldComponent,
    HeadingComponent,
    BadgeComponent,
    TranslatePipe,
    ReactiveFormsModule,
    WysiwygComponent,
    RenderDirective,
    ProsemirrorDefaultConfigDirective,
  ],
})
export class RequisitionsContextFormComponent {
  @Input() public generalContextControl: FormControl<EditorJSONState | object | null>;
  @Input() public isFormEditable: boolean;

  public ProsemirrorConfig = ProsemirrorDefaultConfig;
}
